//var fuwuqi = '/api'
// var fuwuqi = '/tp5/public'
const fuwuqi = 'http://api.zhonghaoyi.cn';
// const fuwuqi = 'http://zhy_api.cn';
const headers = {
	// 'Content-Type': 'multipart/form-data',
	'shebei': 'liulanqi_diannao',
	'renzhengma': '37c1fcf4ab61593978fb0bda44340953',
	'loginkouling': localStorage.getItem("登录口令") || '',
	'loginbianhao': localStorage.getItem("登录口令编号") || ''
};
const headers2 = {
	'Content-Type': 'application/json',
	'shebei': 'liulanqi_diannao',
	'renzhengma': '37c1fcf4ab61593978fb0bda44340953',
	'loginkouling': localStorage.getItem("登录口令") || '',
	'loginbianhao': localStorage.getItem("登录口令编号") || ''
};
export default {
	fuwuqi,
	headers,
	headers2
}